export default __webpack_public_path__ + "images/assets/db476b15c035f009bd032f6afa196e7d.svg";